import styled from 'styled-components';

interface WrapperProps {
  topNav?: boolean;
  isOverflowHidden?: boolean;
  height?: string;
  minHeight?: string;
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ height, minHeight }) =>
    height
      ? `
		height: ${height};
	`
      : `
		min-height: ${minHeight ? minHeight : '100%'};
	`}
  padding-top: ${({ topNav }) => (topNav ? 0 : '3.85rem')};
  ${({ isOverflowHidden }) =>
    isOverflowHidden &&
    `
		overflow: hidden;
	`};
  @media print {
    padding: 0;
    background-color: ${({ theme }) => theme.colors.grey[0]};
  }
`;
